// src/context/ThemeContext.js
import React, {
  createContext,
  useState,
  useLayoutEffect,
  useContext,
} from "react";

// 1. Create the context
const ThemeContext = createContext();

// 2. Create the provider component
export const ThemeProvider = ({ children }) => {
  // Get theme from localStorage or default to 'light'
  const [theme, setTheme] = useState(
    localStorage.getItem("chafadi-theme") || "light"
  );

  // useLayoutEffect runs synchronously BEFORE the browser paints the screen.
  // This is crucial to prevent a "flash" of the wrong theme on page load.
  useLayoutEffect(() => {
    // Apply the theme to the root <html> element
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.style.colorScheme = theme;
    // Save the theme to localStorage
    localStorage.setItem("chafadi-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  const value = {
    theme,
    toggleTheme,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

// 3. Create a custom hook for easy access to the context
export const useTheme = () => {
  return useContext(ThemeContext);
};
